export const boxMenuMobile = () => {
    const boxes = document.querySelectorAll('.c-box-menu--default-mobile-close');
    let windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    if (768 > windowWidth) {
        boxes.forEach((el) => {
            el.classList.add('c-box-menu--close');
        });
    }
}
